import { makeStyles } from '@material-ui/styles';

export const useStyles = (isEng) =>
    makeStyles(() => ({
        info: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap',
        },
        inner: {
            width: '100%',
            display: 'flex',
            flex: '0 0 auto',
            flexDirection: 'row',
            flexWrap: 'wrap',
        },
        fuel: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            margin: 4,
            flex: '1 1 45%',
            [`@media (max-width:${isEng ? '1000' : '1300'}px)`]: {
                flexBasis: '100%',
            },
        },
    }));
